import type { To } from 'react-router';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import styles from './EmptyNetworkHosts.module.css';

type Props = {
  hostNoun: 'host' | 'lighthouse' | 'relay';
  addHostHref: To;
  clearFiltersHref: To;
};

export function EmptyNetworkHosts({ hostNoun, clearFiltersHref, addHostHref }: Props) {
  return (
    <CenteredLayout className={styles.EmptyNetworkHosts}>
      <div>
        <h2 className="h3 mb-24">You have no {hostNoun}s in this network</h2>

        <Spacer stackWhenXNarrow={true}>
          <LinkButton className="width-100 nowrap" to={addHostHref}>
            Add {hostNoun}
          </LinkButton>
          <LinkButton className="width-100 nowrap" to={clearFiltersHref} variant="secondary">
            Show all networks
          </LinkButton>
        </Spacer>
      </div>
    </CenteredLayout>
  );
}
